// TODO: Component under development. Commented code will be removed or added as the Sports module refactoring progresses.
import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  // ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  // Renderer2,
  // inject,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { SportsFormatOddPipe } from "@sports-pipes/sports.format-odd.pipe";
import { SportsGetNameResultPipe } from "@sports-pipes/sports.get-name-result.pipe";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: "sports-bet-button",
  templateUrl: "./sports-bet-button.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, SportsGetNameResultPipe, SportsFormatOddPipe],
  styleUrls: ["./sports-bet-button.scss"],
  host: {
    class: "background-color-button",
  },
})
export class SportsBetButtonComponent implements AfterViewInit {
  @Input() selected: boolean;
  @Input() locked: boolean;
  @Input() game: any;
  @Input() results: any[];

  @Input() mode: string;

  @Input() type: number;
  @Input() typeName: string;
  @Input() index: number;
  @Input() isCombined = false;
  @Input() home: string;
  @Input() away: string;
  @Input() sport: string;

  @Input() sportHandler: string;
  @Output() bet: EventEmitter<any> = new EventEmitter();

  @HostBinding("class.sports-bet-button")
  // private cuotaEspecial = inject(ElementRef);
  // private _renderer = inject(Renderer2);

  @HostBinding("class.disabled")
  get getDisabled(): boolean {
    if (!this.game) {
      return true;
    }
    return this.game.Odd === "-";
  }
  @HostBinding("class.is-selected")
  get getIsSelected(): boolean {
    return !!this.selected;
  }
  @HostBinding("class.locked")
  get getLocket(): boolean {
    return !!this.locked;
  }

  bet$: Observable<any>;
  _bet$: Subscription;
  _previousOdd;

  ngAfterViewInit(): void {
    // if (this.sportHandler === SportHandleList.apuestas_especiales) {
    //   // verificamos si tiene hermanos, es decir, si hay más botones
    //   if (this.cuotaEspecial.nativeElement.nextElementSibling !== null) {
    //     this._renderer.addClass(this.cuotaEspecial.nativeElement, "cuota-especial-25");
    //   } else {
    //     // no tiene hermanos
    //     this._renderer.addClass(this.cuotaEspecial.nativeElement, "cuota-especial-100");
    //   }
    // }
  }

  @HostListener("click")
  onBet() {
    if (this.locked || this.game.Odd === "-") {
      return;
    }
    this.bet.emit(this.game);
  }
}
